export default "__VITE_ASSET__BJtnylFT__"